import React from "react";
import { usePatrolSp } from "./usePatrolSp";
import QrIcon from "../../Assets/qr-icon.png";
import { validateRole } from "../../util/utilFunction";
import UrutanCheck from "../../Assets/urutan-check-printing.png";
import PopUpComponent from "../../components/PopUp/PopUpComponent";
import CloseLogo from "../../Assets/close_icon.png";
import AccordionPatrolSp from "../../components/AccordionPrintingSticker/AccordionPatrolSp";
import Select from "react-select";
import {
  constCustomer,
  shiftTim1,
  shiftTim2,
  rejectSP,
  rejectPR,
  rejectSPTim2,
  rejectPRTim2,
} from "../../util/constant";
import moment from "moment";

import "./PatrolSp.css";

/* =========================================================
   Konstanta & komponen kecil (supaya JSX utama tidak berulang)
   ========================================================= */

const TIPE_OPTIONS = [
  { value: "pasang sticker", label: "Sticker" },
  { value: "punching", label: "Punching" },
  { value: "print", label: "Printing" },
];

const SIDES = [
  { key: "bawah", label: "Bawah" },
  { key: "kiri", label: "Kiri" },
  { key: "atas", label: "Atas" },
  { key: "kanan", label: "Kanan" },
];

const DIM_FIELDS = ["ukuran", "toleransiAtas", "toleransiBawah"];

const TABS = [
  { key: "monitoring", label: "Monitoring" },
  { key: "patrol", label: "Patrol" },
  { key: "validasi", label: "Validasi Awal" },
  { key: "data", label: "Data" },
];

// status scan: "ok" (hijau), "bad" (merah), "idle" (belum scan)
const scanStatus = (value, hasError) =>
  hasError ? "bad" : value ? "ok" : "idle";

const TipeChips = ({ value, onChange }) => (
  <div className="psp_chips" role="radiogroup">
    {TIPE_OPTIONS.map((o) => (
      <button
        key={o.value}
        type="button"
        role="radio"
        aria-checked={value === o.value}
        className={`psp_chip ${value === o.value ? "is_active" : ""}`}
        onClick={() => onChange(o.value)}
      >
        {o.label}
      </button>
    ))}
  </div>
);

const QrTile = ({ label, value, status, onClick }) => (
  <button
    type="button"
    className={`psp_qr_tile ${
      status === "ok" ? "is_ok" : status === "bad" ? "is_bad" : ""
    }`}
    onClick={onClick}
  >
    <span className="psp_qr_value">{value || "Belum di-scan"}</span>
    <img src={QrIcon} alt="" />
    <span className="psp_qr_label">Scan {label}</span>
  </button>
);

const QrPopup = ({ id, scanRef, onClose }) => (
  <PopUpComponent>
    <div ref={scanRef} id={id} className="psp_pop_qr" />
    <div className="psp_pop_footer">
      <button type="button" className="psp_pop_btn_ghost" onClick={onClose}>
        Tutup
      </button>
    </div>
  </PopUpComponent>
);

const DimensiFields = ({ group, onChange }) => (
  <div className="psp_dim_grid">
    <span />
    <span className="psp_dim_head">Ukuran</span>
    <span className="psp_dim_head">Tol. +</span>
    <span className="psp_dim_head">Tol. &#8722;</span>
    {SIDES.map((s) => (
      <React.Fragment key={s.key}>
        <span className="psp_dim_side">{s.label}</span>
        {DIM_FIELDS.map((f) => (
          <input
            key={f}
            type="number"
            className="psp_pop_input"
            onWheel={(e) => e.target.blur()}
            onChange={(e) => onChange(group, s.key, f, e.target.value)}
          />
        ))}
      </React.Fragment>
    ))}
  </div>
);

const Required = () => <span className="psp_req">*</span>;

const PatrolSp = () => {
  const {
    dataUser,
    ref,
    subMenu,
    setSubMenu,
    checlistPunching,
    handleChangeChecklistPunching,
    popUpQrDokumen,
    setPopUpQrDokumen,
    popUpQrMesin,
    setPopUpQrMesin,
    handleCloseScan,
    popUpQrProduk,
    setPopUpQrProduk,
    popUpQrScreen,
    setPopUpQrScreen,
    dokumen,
    mesin,
    produk,
    setTipe,
    dimensi,
    inputUser,
    handleChange,
    error,
    screen,
    tipe,
    handleKirimValidasi,
    hasError,
    isChecklistValid,
    popUpTambahDokumen,
    setPopUpTambahDokumen,

    handleChangeAddNewDokumen,
    addNewDokumenCustomer,
    setAddNewDokumenCustomer,
    addNewDokumenProduk,
    setAddNewDokumenProduk,
    addNewDokumen,
    setAddNewDokumen,
    addNewDokumenScreen,
    setAddNewDokumenScreen,
    handleKirimAddNewDokumen,

    filterCustomer,
    setFilterCustomer,
    listDataValidasi,
    renderDimensi,
    tipePatrol,
    setTipePatrol,
    dataReject,
    addPopUpNewReject,
    setAddPopUpNewReject,
    dateReject,
    setDateReject,
    bagianReject,
    dataSelect,
    jumlahSampling,
    setJumlahSampling,
    rejectPick,
    setRejectPick,
    shiftProduksi,
    setShiftProduksi,
    jumlahReject,
    setJumlahReject,
    alasanRejectSP,
    setAlasanRejectSP,
    addFields,
    handlePickBagian,
    removeFields,
    handleKirimPatrol,
    filterJenis,
    setFilterJenis,
    filterDate,
    setFilterDate,
    filteredData,
    listProduk,
    listMesin,
    filterMesin,
    setFilterMesin,
    filterProduk,
    setFilterProduk,
  } = usePatrolSp();

  const isTim1 = dataUser.tim === 1;
  const shiftList = isTim1 ? shiftTim1 : shiftTim2;
  const alasanList =
    validateRole() === "SP"
      ? isTim1
        ? rejectSP
        : rejectSPTim2
      : isTim1
      ? rejectPR
      : rejectPRTim2;

  const canKirimValidasi = Boolean(
    (!hasError &&
      dokumen &&
      screen &&
      Object.keys(inputUser).length !== 0 &&
      (tipe === "print" || tipe === "pasang sticker")) ||
      (mesin && produk && tipe === "punching" && isChecklistValid())
  );

  const canKirimPatrol = Boolean(
    tipePatrol &&
      jumlahSampling &&
      ((produk !== "" && mesin !== "" && tipePatrol === "punching") ||
        (produk !== "" && mesin !== "" && tipePatrol === "print") ||
        (mesin !== "" && tipePatrol === "pasang sticker"))
  );

  const resetFilter = () => {
    setFilterJenis("Pilih Jenis");
    setFilterProduk("Pilih Produk");
    setFilterMesin("Pilih Mesin");
  };

  return (
    <div className="container_inventory psp">
      {/* ===== Popup scan QR ===== */}
      {popUpQrDokumen && (
        <QrPopup
          id="qr"
          scanRef={ref}
          onClose={() => {
            setPopUpQrDokumen(false);
            handleCloseScan();
          }}
        />
      )}
      {popUpQrMesin && (
        <QrPopup
          id="qr-mesin"
          scanRef={ref}
          onClose={() => {
            setPopUpQrMesin(false);
            handleCloseScan();
          }}
        />
      )}
      {popUpQrScreen && (
        <QrPopup
          id="qr-screen"
          scanRef={ref}
          onClose={() => {
            setPopUpQrScreen(false);
            handleCloseScan();
          }}
        />
      )}
      {popUpQrProduk && (
        <QrPopup
          id="qr-produk"
          scanRef={ref}
          onClose={() => {
            setPopUpQrProduk(false);
            handleCloseScan();
          }}
        />
      )}

      {/* ===== Popup tambah dokumen ===== */}
      {popUpTambahDokumen && (
        <PopUpComponent
          scroll
          style={{
            marginTop: "calc(100vh - 95vh - 20px)",
          }}
        >
          <div className="psp_pop_head">
            <p className="psp_pop_title">Dokumen Baru</p>
            <img
              className="psp_pop_close"
              src={CloseLogo}
              onClick={() => setPopUpTambahDokumen(false)}
              alt="close"
            />
          </div>

          <div className="psp_pop_grid">
            <div className="psp_pop_field">
              <p className="psp_pop_label">Customer</p>
              <select
                className="psp_pop_input"
                value={addNewDokumenCustomer}
                onChange={(e) => setAddNewDokumenCustomer(e.target.value)}
              >
                <option value="Customer" disabled>
                  Customer
                </option>
                {constCustomer.map((ele) => (
                  <option key={ele} value={ele}>
                    {ele}
                  </option>
                ))}
              </select>
            </div>
            <div className="psp_pop_field">
              <p className="psp_pop_label">Produk</p>
              <input
                type="text"
                className="psp_pop_input"
                value={addNewDokumenProduk}
                onChange={(e) =>
                  setAddNewDokumenProduk(e.target.value.toUpperCase())
                }
              />
            </div>
            <div className="psp_pop_field">
              <p className="psp_pop_label">Dokumen</p>
              <input
                type="text"
                className="psp_pop_input"
                value={addNewDokumen}
                onChange={(e) => setAddNewDokumen(e.target.value.toUpperCase())}
              />
            </div>
            <div className="psp_pop_field">
              <p className="psp_pop_label">Screen</p>
              <input
                type="text"
                className="psp_pop_input"
                value={addNewDokumenScreen}
                onChange={(e) =>
                  setAddNewDokumenScreen(e.target.value.toUpperCase())
                }
              />
            </div>
          </div>

          <p className="psp_pop_section">Printing</p>
          <DimensiFields
            group="dimensiPrint"
            onChange={handleChangeAddNewDokumen}
          />

          <p className="psp_pop_section">Sticker</p>
          <DimensiFields
            group="dimensiSticker"
            onChange={handleChangeAddNewDokumen}
          />

          <div className="psp_pop_footer">
            <button
              type="button"
              className="psp_pop_btn_ghost"
              onClick={() => setPopUpTambahDokumen(false)}
            >
              Tutup
            </button>
            <button
              type="button"
              className="psp_pop_btn_primary"
              onClick={() => {
                handleKirimAddNewDokumen();
                setPopUpTambahDokumen(false);
              }}
            >
              Kirim
            </button>
          </div>
        </PopUpComponent>
      )}

      {/* ===== Popup tambah reject ===== */}
      {addPopUpNewReject && (
        <PopUpComponent>
          <div className="psp_pop_head">
            <p className="psp_pop_title">Tambah Reject</p>
            <img
              className="psp_pop_close"
              src={CloseLogo}
              onClick={() => setAddPopUpNewReject(false)}
              alt="close"
            />
          </div>

          <div className="psp_pop_grid">
            <div className="psp_pop_field">
              <p className="psp_pop_label">
                Pilih Tanggal
                <Required />
              </p>
              <input
                type="date"
                className="psp_pop_input"
                value={dateReject}
                onChange={(e) => setDateReject(e.target.value)}
              />
            </div>
            <div className="psp_pop_field">
              <p className="psp_pop_label">Bagian</p>
              <div className="psp_chips" role="radiogroup">
                {["SP", "Produksi"].map((b) => (
                  <button
                    key={b}
                    type="button"
                    role="radio"
                    aria-checked={bagianReject === b}
                    className={`psp_chip ${
                      bagianReject === b ? "is_active" : ""
                    }`}
                    onClick={() => handlePickBagian(b)}
                  >
                    {b}
                  </button>
                ))}
              </div>
            </div>

            {bagianReject === "Produksi" && (
              <>
                <div className="psp_pop_field">
                  <p className="psp_pop_label">Reject Produksi</p>
                  <Select
                    options={dataSelect}
                    value={rejectPick || ""}
                    onChange={setRejectPick}
                  />
                </div>
                <div className="psp_pop_field">
                  <p className="psp_pop_label">Pilih Shift</p>
                  <select
                    className="psp_pop_input"
                    value={shiftProduksi}
                    onChange={(e) => setShiftProduksi(e.target.value)}
                  >
                    <option value="Pilih Shift" disabled>
                      Pilih Shift
                    </option>
                    {shiftList &&
                      shiftList.map((ele) => (
                        <option key={ele} value={ele}>
                          {ele}
                        </option>
                      ))}
                  </select>
                </div>
              </>
            )}

            {bagianReject === "SP" && (
              <div className="psp_pop_field">
                <p className="psp_pop_label">Reject SP</p>
                <select
                  className="psp_pop_input"
                  value={alasanRejectSP}
                  onChange={(e) => setAlasanRejectSP(e.target.value)}
                >
                  <option value="Pilih Alasan" disabled>
                    Pilih Alasan
                  </option>
                  {alasanList &&
                    alasanList.map((ele) => (
                      <option key={ele.desc} value={ele.desc}>
                        {ele.desc}
                      </option>
                    ))}
                </select>
              </div>
            )}

            <div className="psp_pop_field">
              <p className="psp_pop_label">
                Jumlah Reject
                <Required />
              </p>
              <input
                placeholder="Jumlah Reject"
                type="number"
                className="psp_pop_input"
                value={jumlahReject}
                onChange={(e) =>
                  setJumlahReject(e.target.value.split(".").join(""))
                }
                onWheel={(e) => e.target.blur()}
              />
            </div>
          </div>

          <div className="psp_pop_footer">
            <button
              type="button"
              className="psp_pop_btn_primary"
              onClick={() => addFields()}
            >
              Kirim
            </button>
          </div>
        </PopUpComponent>
      )}

      {/* ===== Tab ===== */}
      <div className="psp_tabs" role="tablist">
        {TABS.map((t) => (
          <button
            key={t.key}
            type="button"
            role="tab"
            aria-selected={subMenu === t.key}
            className={`psp_tab ${subMenu === t.key ? "is_active" : ""}`}
            onClick={() => setSubMenu(t.key)}
          >
            {t.label}
          </button>
        ))}
      </div>

      {subMenu === "validasi" ? (
        /* ================= VALIDASI AWAL ================= */
        <>
          <div className="psp_card">
            <img
              className="psp_urutan"
              src={UrutanCheck}
              alt="Urutan check printing"
            />
          </div>

          <div className="psp_card">
            <p className="psp_card_title">Jenis validasi</p>
            <TipeChips value={tipe} onChange={setTipe} />
          </div>

          {tipe === "print" || tipe === "pasang sticker" ? (
            <div className="psp_card">
              <div className="psp_qr_row">
                <QrTile
                  label="Dokumen"
                  value={dokumen}
                  status={scanStatus(dokumen)}
                  onClick={() => setPopUpQrDokumen(true)}
                />
                <QrTile
                  label="Screen"
                  value={screen}
                  status={scanStatus(screen)}
                  onClick={() => setPopUpQrScreen(true)}
                />
              </div>

              {dimensi && (
                <>
                  <p className="psp_card_title" style={{ marginTop: 20 }}>
                    Input dimensi
                  </p>
                  <div className="psp_dim_list">
                    {Object.keys(dimensi).map((posisi) => {
                      const spec = dimensi?.[posisi];
                      if (!spec?.ukuran) return null;

                      const min = spec.ukuran - (spec.toleransiBawah ?? 0);
                      const max = spec.ukuran + (spec.toleransiAtas ?? 0);
                      const nomor =
                        posisi === "bawah"
                          ? "1. "
                          : posisi === "kiri"
                          ? "2. "
                          : posisi === "atas"
                          ? "3. "
                          : posisi === "kanan"
                          ? "4. "
                          : "";

                      return (
                        <div
                          key={posisi}
                          className={`psp_dim_item ${
                            error[posisi] ? "is_error" : ""
                          }`}
                        >
                          <strong className="psp_dim_title">
                            {nomor}
                            {posisi.toUpperCase()}
                          </strong>
                          <input
                            type="number"
                            value={inputUser[posisi] || ""}
                            className="psp_dim_input"
                            min={min}
                            max={max}
                            onChange={(e) =>
                              handleChange(posisi, e.target.value)
                            }
                          />
                          <div className="psp_dim_spec">
                            Spec : {spec.ukuran} | Range : {min} - {max}
                          </div>
                          {error[posisi] && (
                            <div className="psp_dim_error">{error[posisi]}</div>
                          )}
                        </div>
                      );
                    })}
                  </div>
                </>
              )}
            </div>
          ) : tipe === "punching" ? (
            <>
              <div className="psp_card">
                <p className="psp_card_title">Checklist punching</p>
                <div className="psp_table_wrap">
                  <table className="psp_table">
                    <thead>
                      <tr>
                        <th className="psp_col_no">No.</th>
                        <th>Item Check</th>
                        <th className="psp_col_check">Cek</th>
                        <th className="psp_col_check">Trouble</th>
                      </tr>
                    </thead>
                    <tbody>
                      {checlistPunching.map((ele, index) => (
                        <tr key={ele.id ?? index}>
                          <td className="psp_col_no">{index + 1}.</td>
                          <td>{ele.id}.</td>
                          <td className="psp_col_check">
                            <input
                              type="checkbox"
                              name="isChecked"
                              className="psp_checkbox"
                              checked={ele.isChecked}
                              onChange={() =>
                                handleChangeChecklistPunching(index, "check")
                              }
                            />
                          </td>
                          <td className="psp_col_check">
                            <input
                              className="cross-checkbox psp_checkbox"
                              type="checkbox"
                              name="isTrouble"
                              checked={ele.isTrouble}
                              onChange={() =>
                                handleChangeChecklistPunching(index, "trouble")
                              }
                              style={
                                ele.isTrouble
                                  ? {
                                      background: "red",
                                      width: "22px",
                                      height: "22px",
                                    }
                                  : {}
                              }
                            />
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>

              <div className="psp_card">
                <div className="psp_qr_row">
                  <QrTile
                    label="Mesin"
                    value={mesin}
                    status={scanStatus(mesin, error.mesin)}
                    onClick={() => setPopUpQrMesin(true)}
                  />
                  <QrTile
                    label="Produk"
                    value={produk}
                    status={scanStatus(produk, error.produk)}
                    onClick={() => setPopUpQrProduk(true)}
                  />
                </div>
              </div>
            </>
          ) : null}

          {canKirimValidasi && (
            <div className="psp_actions">
              <button
                type="button"
                className="psp_btn psp_btn_primary"
                onClick={() => handleKirimValidasi()}
              >
                Kirim
              </button>
            </div>
          )}
        </>
      ) : subMenu === "data" ? (
        /* ================= DATA ================= */
        <>
          <div className="psp_toolbar">
            <select
              className="psp_select"
              value={filterCustomer}
              onChange={(e) => setFilterCustomer(e.target.value)}
            >
              <option value="Customer" disabled>
                Customer
              </option>
              {constCustomer.map((ele) => (
                <option key={ele} value={ele}>
                  {ele}
                </option>
              ))}
            </select>
            <button
              type="button"
              className="psp_btn psp_btn_add"
              onClick={() => setPopUpTambahDokumen(true)}
            >
              + New Dokumen
            </button>
          </div>

          <div className="psp_table_wrap">
            <table className="psp_table">
              <thead>
                <tr>
                  <th className="psp_col_no">No.</th>
                  <th>Produk</th>
                  <th>Dokumen</th>
                  <th>Screen</th>
                  <th>Printing</th>
                  <th>Sticker</th>
                </tr>
              </thead>
              <tbody>
                {listDataValidasi && listDataValidasi.length > 0 ? (
                  listDataValidasi.map((ele, index) => (
                    <tr key={ele.id ?? index}>
                      <td className="psp_col_no">{index + 1}.</td>
                      <td className="psp_nowrap psp_strong">{ele.nama}</td>
                      <td className="psp_nowrap">{ele.dokumen}</td>
                      <td className="psp_nowrap">{ele.screen}</td>
                      <td className="psp_nowrap">
                        {renderDimensi(ele.dimensiPrint)}
                      </td>
                      <td className="psp_nowrap">
                        {renderDimensi(ele.dimensiSticker)}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td className="psp_empty" colSpan={6}>
                      Belum ada data
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </>
      ) : subMenu === "patrol" ? (
        /* ================= PATROL ================= */
        <>
          <div className="psp_card">
            <p className="psp_card_title">Jenis patrol</p>
            <TipeChips value={tipePatrol} onChange={setTipePatrol} />

            <p className="psp_card_title" style={{ marginTop: 18 }}>
              Jumlah sampling
            </p>
            <div className="psp_inline">
              <input
                type="number"
                className="psp_input_sm"
                placeholder="Jml. Sampling"
                value={jumlahSampling > 0 ? jumlahSampling : ""}
                onChange={(e) => setJumlahSampling(e.target.value)}
                onWheel={(e) => e.target.blur()}
              />
              <span className="psp_unit">Pcs</span>
            </div>
          </div>

          <div className="psp_card">
            <div className="psp_card_head">
              <p className="psp_card_title">Kind of reject</p>
              <div className="psp_inline">
                <button
                  type="button"
                  className="psp_btn_round"
                  onClick={() => removeFields()}
                  aria-label="Kurangi reject"
                >
                  &#8722;
                </button>
                <button
                  type="button"
                  className="psp_btn_round"
                  onClick={() => setAddPopUpNewReject(true)}
                  aria-label="Tambah reject"
                >
                  &#43;
                </button>
              </div>
            </div>

            <div className="psp_table_wrap">
              <table className="psp_table">
                <thead>
                  <tr>
                    <th>Reject</th>
                    <th>Tgl</th>
                    <th>Bagian</th>
                    <th className="psp_num">Total</th>
                  </tr>
                </thead>
                <tbody>
                  {dataReject && dataReject.length > 0 ? (
                    dataReject.map((obj, index) => (
                      <tr key={index}>
                        <td>{obj.id}</td>
                        <td className="psp_nowrap">
                          {moment(obj.dateReject)
                            .utcOffset(7)
                            .format("DD-MM-YYYY")}
                        </td>
                        <td>{obj.shift ? obj.shift : obj.bagian}</td>
                        <td className="psp_num">{obj.reject}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td className="psp_empty" colSpan={4}>
                        Belum ada reject
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>

          <div className="psp_card">
            <div className="psp_qr_row">
              <QrTile
                label="Mesin"
                value={mesin}
                status={scanStatus(mesin, error.mesin)}
                onClick={() => setPopUpQrMesin(true)}
              />
              {tipePatrol !== "pasang sticker" && (
                <QrTile
                  label="Produk"
                  value={produk}
                  status={scanStatus(produk, error.produk)}
                  onClick={() => setPopUpQrProduk(true)}
                />
              )}
            </div>
          </div>

          {canKirimPatrol && (
            <div className="psp_actions">
              <button
                type="button"
                className="psp_btn psp_btn_primary"
                onClick={() => handleKirimPatrol()}
              >
                Kirim
              </button>
            </div>
          )}
        </>
      ) : (
        /* ================= MONITORING ================= */
        <>
          <div className="psp_toolbar">
            <input
              type="date"
              className="psp_date"
              value={filterDate}
              onChange={(e) => setFilterDate(e.target.value)}
            />
            <select
              className="psp_select"
              onChange={(e) => setFilterJenis(e.target.value)}
              value={filterJenis}
            >
              <option value="Pilih Jenis" disabled>
                Pilih Jenis
              </option>
              <option value="print">Printing</option>
              <option value="punching">Punching</option>
              <option value="pasang sticker">Pasang Sticker</option>
              <option value="patrol">Patrol</option>
            </select>

            {filterJenis === "patrol" && (
              <select
                className="psp_select"
                value={filterMesin || "Pilih Mesin"}
                onChange={(e) => setFilterMesin(e.target.value)}
              >
                <option value="Pilih Mesin" disabled>
                  Pilih Mesin
                </option>
                {listMesin.map((item, index) => (
                  <option key={index} value={item}>
                    {item}
                  </option>
                ))}
              </select>
            )}

            {(filterJenis === "print" ||
              filterJenis === "punching" ||
              filterJenis === "pasang sticker") && (
              <select
                className="psp_select"
                value={filterProduk || "Pilih Produk"}
                onChange={(e) => setFilterProduk(e.target.value)}
              >
                <option value="Pilih Produk" disabled>
                  Pilih Produk
                </option>
                {listProduk.map((item, index) => (
                  <option key={index} value={item}>
                    {item}
                  </option>
                ))}
              </select>
            )}

            <button
              type="button"
              className="psp_btn psp_btn_accent"
              onClick={resetFilter}
            >
              Reset
            </button>
          </div>

          <AccordionPatrolSp data={filteredData && filteredData} />
        </>
      )}
    </div>
  );
};
export default PatrolSp;
